import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";

import Header from "common-components/Header";
import StyledLink from "common-components/StyledLink";
import Container from "common-components/Container";

class RenewRemoveAuthAgentSuccess extends Component {
  state = {
    section_title: "",
    section_description: "",
    buttons: [{ type: "", text: "" }]
  };

  componentDidMount() {
    if (checkNestedObject(this.props, "location", "state", "type")) {
      const { type } = this.props.location.state;
      const { remove_agent_success, renew_agent_success } = this.props;

      if (type === "Cancel") {
        this.setState({ ...remove_agent_success });
      } else {
        this.setState({ ...renew_agent_success });
      }
    }
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("authorized agent information", this.props.pageContent.sc_pagetitle);
    }
  }

  render() {
    if (!checkNestedObject(this.props, "renew_agent_success", "section_title")) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    const { section_title, section_description, buttons } = this.state;

    return (
      <Container>
        <Header>{section_title}</Header>

        <Div>{convertStringToElements(section_description)}</Div>

        <StyledLink
          background={buttons[0].type}
          style={{ marginTop: "16px" }}
          to={"/privacy/secure/your-data"}
        >
          {buttons[0].text}
        </StyledLink>
      </Container>
    );
  }
}

const mapStateToProps = ({ pageContent: { renew_agent_success, remove_agent_success } }) => ({
  renew_agent_success,
  remove_agent_success
});

export default connect(
  mapStateToProps,
  { setA11yContent }
)(RenewRemoveAuthAgentSuccess);

const Div = styled.div`
  margin: 40px 0;

  p {
    margin: 12px 0;
  }

  p strong {
    font-size: 20px;
    line-height: 19px;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  }

  ul {
    list-style: disc inside;
    margin: 15px 0;
  }
`;
